var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrivacy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.217 1.024a1 1 0 00-.434 0l-9 2A1 1 0 002 4v10a10 10 0 0020 0V4a1 1 0 00-.783-.976l-9-2zM4 14V4.802l8-1.778 8 1.778V14a8 8 0 01-16 0zm8-6a1.006 1.006 0 00-1 1.002V11h2V9.002A1.006 1.006 0 0012 8zM9 9v2H8a1 1 0 00-1 1v5a1 1 0 001 1h8a1 1 0 001-1v-5a1 1 0 00-1-1h-1V8.997A3.006 3.006 0 0012.003 6L12 7l-.003-1A3.006 3.006 0 009 8.997V9zm0 4h6v3H9v-3z"
  })));
}
export default SvgPrivacy;